import { useFetchFeatures } from 'hooks/api/feature-control/use-fetch-features';
import { useProductData } from 'hooks/api/use-product-data';
import { FeatureNames } from 'services/api/feature-control/interfaces';
import { getScopes } from 'services/auth/auth-storage-manager';

import { hasLegacyMigrationBillingPermission, hasLegacyMigrationProducts } from './helpers';

interface LegacyMigrationEligibility {
  isEligible: boolean;
  isFetched: boolean;
}

export function useLegacyMigrationEligibility(): LegacyMigrationEligibility {
  const { data: features, isFetched: areFeaturesFetched } = useFetchFeatures();
  const { installedProducts, areProductsFetched } = useProductData();
  const scopes = getScopes() ?? [];

  return {
    isEligible:
      features[FeatureNames.LegacyProductsMigrationCampaign] &&
      hasLegacyMigrationProducts(installedProducts) &&
      hasLegacyMigrationBillingPermission(scopes),
    isFetched: areFeaturesFetched && areProductsFetched,
  };
}
